import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { ReportDataSource } from '@app/modules/report-designer/models/report-designer.model';
import { ReportDesignerService } from '@app/modules/report-designer/services/report-designer.service';
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-report-data-source-form-field',
  templateUrl: './report-data-source-form-field.component.html',
  styleUrls: ['./report-data-source-form-field.component.scss']
})
export class ReportDataSourceFormFieldComponent {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  isLoading: boolean;
  user$: any;
  filterString: string;
  options: Observable<PagedData<ReportDataSource>>;

  constructor(
    private reportDesignerService: ReportDesignerService,
  ) { }

  ngOnInit(): void {
    this.options = from(this.reportDesignerService.getAllReportDataSources())
  }
}